import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import {
    getSmartyAutocompleteSuggestions,
    AddressSuggestion,
} from "@tCentro/Services/CENSmartyAutocomplateServices";

/**
 * Props passed to handler
 * (search parameter + onSuccess/onError callbacks)
 */
type Props = {
    search: string;
} & HasOnSuccess<AddressSuggestion[]>;

/**
 * Handler type
 */
type HandlerType = ApiHandler<Props, AddressSuggestion[]>;




/**
 * Call Smarty autocomplete API and return suggestions on success
 */
export const CENSmartyAutocomplateHandler: HandlerType = async props => {
    const result = await getSmartyAutocompleteSuggestions({ search: props.parameter.search });

    props.parameter.onSuccess?.(result);

};

/**
 * Handler chain
 */

const chain = [CENSmartyAutocomplateHandler];
const getSmartyAutocomplete = createHandlerChainRunner(chain, "getSmartyAutocomplete");
export default getSmartyAutocomplete;
;
